import { EHeadingStyleVariant, Heading, Textarea } from '@outdoorsyco/bonfire';
import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { EPersonalInfoFields, TPersonalInfoValues } from '../ProfileEdit';

interface IAboutProps {
  control: Control<TPersonalInfoValues>;
  errors: FieldErrors<TPersonalInfoValues>;
}

const MAX_TEXT_AREA_LENGTH = 1_000;

export const About = ({ control, errors }: IAboutProps) => {
  const intl = useIntl();

  return (
    <div id="aboutMeZone" className="mb-2 md:mb-0">
      <Heading variant={EHeadingStyleVariant.H6} className="mb-6">
        <FormattedMessage defaultMessage="About me" id="1I78TO" />
      </Heading>
      <div className="pt-3 mb-2">
        <Controller
          control={control}
          name={EPersonalInfoFields.Description}
          rules={{
            maxLength: {
              value: MAX_TEXT_AREA_LENGTH,
              message: intl.formatMessage(
                {
                  defaultMessage: 'About text length cannot be greater than {maxLength}',
                  id: '/Ybv/W',
                },
                {
                  maxLength: MAX_TEXT_AREA_LENGTH,
                },
              ),
            },
          }}
          render={({ field: { value, onChange } }) => {
            return (
              <Textarea
                maxLength={MAX_TEXT_AREA_LENGTH}
                inputValue={value || ''}
                onChange={onChange}
                ariaLabel={intl.formatMessage({
                  defaultMessage: 'About input textarea',
                  id: 'mpfjpl',
                })}
                placeholder={intl.formatMessage({
                  defaultMessage:
                    'Share what you love and how you enjoy the outdoors. Let guests get to know you and your passions. This will be displayed on your public profile.',
                  id: 'kJ6NH0',
                })}
                rows={6}
                error={!!errors.description}
                helpText={errors.description?.message}
                controlled
              />
            );
          }}
        />
      </div>
    </div>
  );
};
